module.exports = __webpack_public_path__ + "img/ic_64_feature_regelwerk.9f764a72.svg";